import { GetTaskDetailListData } from '@/api/fishing-task-detail'
import {
  DeleteModal,
  DraggingTableHeaders,
  FilterForm,
  IconFont,
  SignTitle,
  TableTag,
} from '@/components'
import { Dispaths } from '@/types'
import { Card, Form, Tooltip, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { ListExpandable } from './list-expandable'
import Scrollbars from 'react-custom-scrollbars'
import { useDebounceFn } from 'ahooks'
import { useGetThrough } from './utils'
const { useForm } = Form

interface ListProps {
  taskDetailList: any
  getTaskDetailListParams: GetTaskDetailListData
  setGetTaskDetailListParams: Dispaths<GetTaskDetailListData>
  type: '钓鱼链接' | '恶意附件'
  group: { tag_str: string; group_str: string }
  status: number
  detailList: any
  getTaskBasic: any
  getTaskDetailList: () => void
  getTaskStd: () => void
}

export const List = (props: ListProps) => {
  const {
    taskDetailList,
    setGetTaskDetailListParams,
    type,
    group,
    status,
    detailList,
    getTaskBasic,
    getTaskDetailList,
    getTaskStd,
    getTaskDetailListParams,
  } = props
  const [createForm] = useForm()
  const columns: ColumnsType<any> = [
    {
      title: <div style={{ paddingLeft: 16 }}>{t('邮件')}</div>,
      dataIndex: 'email',
      width: 240,
      render: value => (
        <Tooltip title={value}>
          <div
            style={{
              maxWidth: '240px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              paddingLeft: 16,
            }}
          >
            {value}
          </div>
        </Tooltip>
      ),
    },
    {
      title: t('姓名'),
      dataIndex: 'name',
      width: 150,
      render: value => (
        <div
          style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {value || '-'}
        </div>
      ),
    },
    {
      title: t('标签'),
      dataIndex: 'tag_list',
      width: 300,
      searchType: 'multiple',
      render: (_, record) => (
        <div>
          {record?.tags?.split(',')?.map((item, index) => {
            const random = Math.floor(Math.random() * 3) + 1
            let arr = ['#65BDC0', '#1E2243', '#558492', '#65BDC0', '#1E2243', '#558492']
            if (index <= 5) {
              return (
                <TableTag
                  background={
                    (item === '已离职' && '#AFAFAF') ||
                    (item === '新入职' && '#67C23A') ||
                    (item === '已评估' && '#3257B9') ||
                    (item === '邮箱收集' && '#ED7780') ||
                    (item === '业务邮箱' && '#AA56FF') ||
                    arr[index]
                  }
                  color="#fff"
                  key={index}
                  style={{ marginRight: 5, whiteSpace: item.length < 4 ? 'nowrap' : '' }}
                >
                  {item}
                </TableTag>
              )
            }
            if (index === 5) {
              return <span key={index}>...</span>
            }
          })}
          {record?.tags ? '' : '-'}
        </div>
      ),
    },
    {
      title: t('部门'),
      dataIndex: 'dept_name',
      width: 240,
      searchType: 'radio',
      render: text => (
        <Typography.Text ellipsis={{ tooltip: text }} style={{ maxWidth: 100 }}>
          {text}
        </Typography.Text>
      ),
    },
    {
      title: t('人员状态'),
      dataIndex: 'status',
      width: 100,
      searchType: 'radio',
      render: value => {
        if (value === 1 || value === 2) {
          return (
            <div style={{ width: 100 }}>
              <TabTag color="#67C23A" bgColor="#F2F9EB">
                {t('发送邮件')}
              </TabTag>
            </div>
          )
        }
        if (value === 3) {
          return (
            <div style={{ width: 100 }}>
              <TabTag color="#2973FF" bgColor="#E9F1FF">
                {/* {type === '恶意附件' ? '已打开附件' : '已点击链接'} */}
                {t('查看邮件')}
              </TabTag>
            </div>
          )
        }
        if (value === 4) {
          return (
            <div style={{ width: 100 }}>
              <TabTag color="#F6BD16" bgColor="#FEF8E7">
                {/* {type === '恶意附件' ? '已打开附件' : '已点击链接'} */}
                {t('点击链接')}
              </TabTag>
            </div>
          )
        }
        if (value === 5) {
          return (
            <div style={{ width: 100 }}>
              <TabTag color="#F6BD16" bgColor="#FEF8E7">
                {/* {type === '恶意附件' ? '已打开附件' : '已点击链接'} */}
                {t('打开附件')}
              </TabTag>
            </div>
          )
        }
        if (value === 6) {
          return (
            <div style={{ width: 100 }}>
              <TabTag color="#9791FF" bgColor="#F4F3FF">
                {/* {type === '恶意附件' ? '已打开附件' : '已点击链接'} */}
                {t('提交数据')}
              </TabTag>
            </div>
          )
        }
        return t('未知')
      },
    },
    {
      title: <div>{t('安全意识')}</div>,
      dataIndex: 'aware',
      width: 100,
      searchType: 'radio',
      render: value => (
        <>
          {value === '优秀' && (
            <TableTag background="#D6F4C7" color="#5BC825" style={{ border: 0 }}>
              {value}
            </TableTag>
          )}
          {value === '良好' && (
            <TableTag background="#E2E4FF" color="#2973FF" style={{ border: 0 }}>
              {value}
            </TableTag>
          )}
          {value === '较差' && (
            <TableTag background="#FFEBB4" color="#FFA709" style={{ border: 0 }}>
              {value}
            </TableTag>
          )}
          {value === '差' && (
            <TableTag background="#FFC9C9" color="#FF2929" style={{ border: 0 }}>
              {value}
            </TableTag>
          )}
        </>
      ),
    },
    {
      title: t('识破钓鱼'),
      dataIndex: 'see_through',
      width: '100px',
      searchType: 'radio',
      render: (value, record) => (value === 1 ? t('是') : t('否')),
    },
  ]
  let [emilId, setEmilId] = useState({
    email: '',
    sid: '',
    id: null,
    dateline: [{}],
    status: 0,
    see_through: null,
  })
  useEffect(() => {
    if (taskDetailList?.items) {
      let taskData = taskDetailList?.items?.[0]
      if (changeId) {
        taskData = taskDetailList?.items?.filter(item => item.sid === changeId)?.[0]
      }
      setRowId(taskData?.id)
      setEmilId({
        ...taskData,
        // email: taskData?.email,
        // sid: taskData?.sid,
        // id: taskData?.id,
        // dateline: taskData?.dateline,
        // status: taskData?.status,
      })
    }
  }, [taskDetailList?.items])
  const [changeId, setChangeId] = useState(null)
  const [rowId, setRowId] = useState('')
  const [selectRow, setSelectRow] = useState()
  const [key, setKey] = useState(0)
  const [filterParams, setFilterParams] = useState<{ [k: string]: string | number | undefined }>()
  const setTableRowClassName = record => (record.id === rowId ? 'clickRowSty1' : '')
  const onClickTableRow = record => ({
    onClick: () => {
      setRowId(record.id)
      setSelectRow(record)
      // console.log('id in click', record.id)
      setEmilId((emilId = record))
    },
  })
  useEffect(() => {
    let arr = []
    group?.tag_str?.split(',')?.map(item => arr.push(item))
    createForm.setFieldsValue({ groupList: arr })
  }, [group])
  const { run } = useDebounceFn(
    values => {
      setGetTaskDetailListParams(origin => ({ ...origin, keyword: values, page: 1 }))
    },
    {
      wait: 500,
    },
  )
  const { run: runKey } = useDebounceFn(
    d => {
      if (key === 0) setKey(key + 1)
    },
    {
      wait: 500,
    },
  )
  const Group = useMemo(() => {
    let arr = []
    if (group?.tag_str) {
      group?.tag_str?.split(',')?.map((item, index) => {
        arr.push({ id: item, visible: false, name: item })
      })
    }
    return arr
  }, [group?.tag_str])
  const DeptName = useMemo(() => {
    let arr = []
    if (group?.group_str) {
      group?.group_str?.split(',')?.map((item, index) => {
        arr.push({ id: item, visible: false, name: item })
      })
    }
    return arr
  }, [group?.group_str])
  const Status = useMemo(() => {
    let arr = [
      { name: '发送邮件', id: 2 },
      { name: '查看邮件', id: 3 },
    ]
    if (getTaskBasic?.data?.email_type === '钓鱼链接') {
      arr.push(
        {
          name: '点击链接',
          id: 4,
        },
        {
          name: '提交信息',
          id: 6,
        },
      )
    } else if (getTaskBasic?.data?.email_type === '恶意附件') {
      arr.push({
        name: '打开附件',
        id: 5,
      })
    }
    return arr
  }, [getTaskBasic?.data?.email_type])
  let option = {
    keyword: {
      type: 'input',
      label: t('邮箱/姓名'),
    },
    tag_list: {
      type: 'multiple',
      label: t('标签'),
      data: Group,
      typeof: 'array',
    },
    dept_name: {
      type: 'radio',
      label: t('部门'),
      data: DeptName,
    },
    status: {
      type: 'radio',
      label: t('人员状态'),
      data: Status,
    },
    aware: {
      type: 'radio',
      label: t('安全意识'),
      data: [
        {
          id: '优秀',
          name: t('优秀'),
        },
        {
          id: '良好',
          name: t('良好'),
        },
        {
          id: '较差',
          name: t('较差'),
        },
        {
          id: '差',
          name: t('差'),
        },
      ],
    },
    see_through: {
      type: 'radio',
      label: t('识破钓鱼'),
      data: [
        {
          id: 2,
          name: t('未识破'),
        },
        {
          id: 1,
          name: t('已识破'),
        },
      ],
    },
  }
  useEffect(() => {
    runKey(option)
  }, [option])
  const onFinish = values => {
    const { time, groupList, dept_name, status, aware, see_through } = values
    setGetTaskDetailListParams(origin => ({
      ...origin,
      tag_list: groupList,
      dept_name,
      status,
      aware,
      see_through,
      page: 1,
    }))
    setVisible(false)
  }
  const [through, setThrough] = useState({ visible: false, id: null })
  const [getThrough, throughLoading] = useGetThrough()
  const [visible, setVisible] = useState(false)
  return (
    <EmilList>
      <ListContaienr
        title={
          <div style={{ display: 'flex' }}>
            <SignTitle style={{ width: '100%', marginLeft: 5 }}>{t('评估目标')}</SignTitle>
          </div>
        }
      >
        <div>
          <FilterForm
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            option={option}
            setFilterHeight={v => {}}
            setSearchParams={setGetTaskDetailListParams}
            onReset={() => {
              setGetTaskDetailListParams(origin => ({
                ...origin,
                keyword: undefined,
                groupList: undefined,
                dept_name: undefined,
                status: undefined,
                aware: undefined,
                see_through: undefined,
                tag_list: undefined,
                page: 1,
                limit: 10,
              }))
            }}
          />
        </div>
        <div style={{ padding: '0 20px' }} id="table-box">
          <DraggingTableHeaders
            columns={columns}
            option={option}
            key={key}
            onRow={onClickTableRow}
            rowSelection={{ renderCell: () => null, hideSelectAll: true, columnWidth: 12 }}
            dataSource={taskDetailList?.items}
            scroll={{ x: 'max-content' }}
            rowKey="id"
            searchParams={getTaskDetailListParams}
            setSearchParams={setGetTaskDetailListParams}
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            total={taskDetailList?.total}
          />
        </div>
      </ListContaienr>
      <DeleteModal
        onOk={async () => {
          try {
            await getThrough({ sid: through.id })
            await getTaskDetailList()
            await getTaskStd()
            setThrough({ visible: false, id: null })
          } catch (error) {}
        }}
        visible={through.visible}
        title={t('提示')}
        confirmLoading={throughLoading}
        text={t('请确认该测试者已识破钓鱼邮件，操作将影响评估结果，是否继续？')}
        onCancel={() => {
          setThrough({ visible: false, id: null })
        }}
      />
      <RightContaienr
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <SignTitle style={{ width: '100%', marginLeft: 5 }}>{t('时间线')}</SignTitle>
            </div>
            <div style={{ display: 'flex' }}>
              <IconFont
                type={'icon-fasongyoujian'}
                style={{
                  height: 20,
                  fontSize: 26,
                  display: 'flex',
                  alignItems: 'center',
                  color: emilId?.status >= 2 ? '#0E42D2' : '#999',
                }}
              />
              <IconFont
                type={'icon-yidudianjihou'}
                style={{
                  margin: '0 10px',
                  fontSize: 20,
                  color: emilId?.status >= 3 ? '#0E42D2' : '#999',
                }}
              />
              {type === '钓鱼链接' && (
                <IconFont
                  type={'icon-shubiaodianji'}
                  style={{
                    color: emilId?.status >= 4 ? '#0E42D2' : '#999',
                    height: 20,
                    fontSize: 24,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
              )}
              <IconFont
                style={{
                  color: '#999',
                  color:
                    type === '钓鱼链接'
                      ? emilId?.status >= 6
                        ? '#0E42D2'
                        : '#999'
                      : emilId?.status >= 5
                      ? '#0E42D2'
                      : '#999',
                  marginLeft: '10px',
                  height: 20,
                  fontSize: 24,
                  display: 'flex',
                  alignItems: 'center',
                }}
                type={type === '钓鱼链接' ? 'icon-shangchuanshuju' : 'icon-wenjian11'}
              />
            </div>
          </div>
        }
      >
        <Scrollbars>
          <ListExpandable
            email={emilId.email}
            sid={emilId.sid}
            id={emilId.id}
            dateline={emilId.dateline}
            detailList={detailList}
            seeThrough={emilId.see_through}
            status={status}
            change={async val => {
              // console.log('id from change', val)
              setChangeId(val)
              await getTaskDetailList()
              await getTaskStd()
            }}
          />
        </Scrollbars>
      </RightContaienr>
    </EmilList>
  )
}
const EmilList = styled.div`
  display: flex;
  margin-top: 16px;
  .ant-popover-title {
    height: 50px;
    display: flex;
    align-items: center;
  }
  .search-button {
    background: #f1f3f8;
    border-radius: 6px;
    padding: 9px 18px;
    margin-left: 10px;
    cursor: pointer;
    &:hover {
      color: #0b0a27;
      background: #e2e4f6;
    }
  }
`
const ListContaienr = styled(Card)`
  width: 71%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .clickRowSty1 {
    background-color: #eaedf3;
  }
  .filter {
    margin-right: 16px;
    margin-bottom: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
  .ant-card-body {
    padding: 20px 0;
  }
  /* .ant-table-measure-row {
    visibility: collapse;
  } */
  .ant-table-cell-scrollbar:not([rowspan]) {
    box-shadow: unset;
  }
`
interface TabTagProps {
  color: string
  bgColor: string
}
const RightContaienr = styled(Card)`
  width: 29%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  margin-left: 16px;
  height: 835px;
`
export const TabTag = styled.div<TabTagProps>`
  box-sizing: border-box;
  display: inline;
  padding: 5px 10px;
  color: ${props => props.color};
  border: 1px solid ${props => props.color};
  background-color: ${props => props.bgColor};

  border-radius: 4px;
`
